import { useEffect, useState, useMemo, useCallback } from "react"
import assoc from "ramda/es/assoc"
import get from "lodash/get"
import { getFields } from "src/engine/repositories/resourceTypeFields"

const initialState = {
  fields: [],
  count: null,
  pending: false,
}

export default queryParams => {
  const {
    query: { limit, offset, orderBy, query },
  } = queryParams
  const [refreshed, setRefreshed] = useState(Date.now())
  const refresh = useCallback(() => {
    setRefreshed(Date.now())
  }, [])

  const [state, setState] = useState(initialState)
  useEffect(() => {
    setState(assoc(`pending`, true))
    getFields(queryParams)
      .then(response => {
        const totalCount = get(response, `headers.total-count`)
        setState({
          fields: get(response, `data`),
          count: Number(totalCount),
          pending: false,
        })
      })
      .catch(() => setState(initialState))
  }, [offset, limit, orderBy, query, refreshed])
  return useMemo(() => ({ state, refresh }), [state])
}
